/**
 * Created by hj on 2017/9/4.
 */
import {config, request} from 'Utils';

export function fetchList(param) {
    return request(`${config.server}/api/v1/dms/tgCustItemMap/list`, {
        method: 'post',
        body: param
    });
}

export function updateItemMap(param) {
    return request(`${config.server}/api/v1/dms/tgCustItemMap/updateItemMap`, {
        method: 'post',
        body: param
    });
}

export function removeItemMap(param) {
    return request(`${config.server}/api/v1/dms/tgCustItemMap/removeItemMap`, {
        method: 'post',
        body: param
    });
}

export function addItemMap(param) {
    return request(`${config.server}/api/v1/dms/tgCustItemMap/addItemMap`, {
        method: 'post',
        body: param
    });
}

export function deliveryInvoice(param) {
    return request(`${config.server}/api/v1/dms/tgCustItemMap/deliveryInvoice`, {
        method: 'post',
        body: param
    });
}


// WEBPACK FOOTER //
// ./src/service/invoiceItemMap/index.js